// src/components/ContactSection.jsx
import React, { useState } from 'react';
import { sendContactMessage } from '../services/userApi';
import '../styles/ContactSection.css';

const ContactSection = () => {
  const [mensaje, setMensaje] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !mensaje.trim()) return;
    setStatus('sending');
    setErrorMsg('');
    try {
      await sendContactMessage({
        nombre: email,
        email,
        asunto: 'Solicitud desde página principal',
        mensaje,
      });
      setStatus('success');
      setMensaje('');
      setEmail('');
    } catch {
      setStatus('error');
      setErrorMsg('No se pudo enviar. Por favor intenta de nuevo.');
    }
  };

  return (
    <section id="contacto" className="contact-section">
      {/* ── Header Section ── */}
      <div className="contact-header">
        <div className="container">
          <div className="contact-header-content">
            <span className="contact-header-label">COMUNIDAD AECBLOCK</span>
            <h2 className="contact-header-title">
              ¿Qué herramienta te haría<br />
              <span className="contact-title-highlight">la vida más fácil hoy?</span>
            </h2>
            <p className="contact-header-subtitle">
              Cuéntanos qué necesitas. Cada respuesta moldea el catálogo que la comunidad construye juntos.
            </p>
          </div>
        </div>
      </div>

      {/* ── Form Section ── */}
      <div className="contact-form-wrapper py-5">
        <div className="container">
          <div className="contact-card">

            {/* ── Heading ── */}
            <h2 className="contact-heading mb-4">Completa el formulario</h2>

          {/* ── Form ── */}
          <form onSubmit={handleSubmit}>
            <textarea
              className="contact-textarea mb-3"
              placeholder="Ej: necesito familias paramétricas de tableros eléctricos para Revit 2024 con criterios técnicos y parámetros listos para documentación..."
              value={mensaje}
              onChange={e => setMensaje(e.target.value)}
              required
            />

            <div className="contact-email-row mb-2">
              <input
                type="email"
                className="form-control"
                placeholder="tu@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <button
                type="submit"
                className="btn-send"
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'Enviando…' : 'Enviar solicitud'}
              </button>
            </div>

            <p className="contact-spam-note">
              🔒 Sin spam. Solo te escribiremos si encontramos o desarrollamos un recurso alineado con lo que buscas.
            </p>

            {status === 'success' && (
              <p className="contact-feedback-success mt-2">
                ✅ ¡Gracias! Nos pondremos en contacto contigo pronto.
              </p>
            )}
            {status === 'error' && (
              <p className="contact-feedback-error mt-2">{errorMsg}</p>
            )}
          </form>

        </div>
      </div>
      </div>
    </section>
  );
};

export default ContactSection;
